module.exports = __webpack_public_path__ + "img/service.f34ba106.png";